import { axios } from '@Root/API'

export const getCognito = () => axios.get('handbook/cognito')
export const getCognitoFields = table => axios.get(`handbook/cognito/fields/${table}`)
export const getCognitoSync = () => axios.get('handbook/cognito/sync')
export const getStudentImport = () => axios.get('handbook/import/students')
export const getReference = () => axios.get('handbook/reference')
export const getReferenceTable = table => axios.get(`handbook/reference/${table}`)
